import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../../context/AuthContext";
import { ENDPOINTS } from "../../../../config/api";

const UpdateProposal = () => {

  const { id } = useParams();
  const navigate = useNavigate();
  const { authFetch } = useContext(AuthContext);

  const [entities,setEntities] = useState([]);
  const [departments,setDepartments] = useState([]);

  const [formData,setFormData] = useState({
    id_entidad:"",
    type_population:"",
    object:"",
    department:[],
    municipality:"",
    start_date:"",
    end_date:"",
    presupuesto_entity:"",
    presupuesto_presencia:""
  });

  const [files,setFiles] = useState({
    doc_contratante:null,
    doc_propuesta_presencia:null,
    doc_evaluacion_propuesta:null
  });

  const [error,setError] = useState("");
  const [success,setSuccess] = useState("");



  // ===============================
  // CARGAR PROPUESTA
  // ===============================

  useEffect(()=>{

    const loadProposal = async()=>{

      const res = await authFetch(`${ENDPOINTS.getProposalById}?id=${id}`);

      if(res.success){

        const proposal = res.data;

        let departmentArray = [];

        try{
          departmentArray = JSON.parse(proposal.department);
        }catch{
          departmentArray = [];
        }

        setFormData({
          id_entidad:proposal.id_entidad,
          type_population:proposal.type_population,
          object:proposal.object,
          department:departmentArray,
          municipality:proposal.municipality,
          start_date:proposal.start_date,
          end_date:proposal.end_date,
          presupuesto_entity:proposal.presupuesto_entity,
          presupuesto_presencia:proposal.presupuesto_presencia
        });

      }

    };

    loadProposal();

  },[id,authFetch]);


  // ===============================
  // CARGAR ENTIDADES
  // ===============================

  useEffect(()=>{

    const loadEntities = async()=>{

      const res = await authFetch(ENDPOINTS.getEntityActive);

      if(res.success){
        setEntities(res.entidades);
      }

    };

    loadEntities();

  },[authFetch]);


  // ===============================
  // CARGAR DEPARTAMENTOS
  // ===============================

  useEffect(()=>{

    const loadDepartments = async()=>{

      const res = await authFetch(ENDPOINTS.getDepartmentCol);

      if(res.success){
        setDepartments(res.data);
      }

    };

    loadDepartments();

  },[authFetch]);



  // ===============================
  // INPUTS
  // ===============================

  const handleChange = (e)=>{

    const {name,value} = e.target;

    setFormData({
      ...formData,
      [name]:value
    });

  };


  // ===============================
  // DEPARTAMENTOS MULTIPLE
  // ===============================

  const handleDepartmentChange = (e)=>{

    const selected = Array.from(
      e.target.selectedOptions,
      option=>option.value
    );

    setFormData({
      ...formData,
      department:selected
    });

  };


  // ===============================
  // ARCHIVOS
  // ===============================

  const handleFileChange = (e)=>{

    const {name,files:file} = e.target;

    if(!file[0]) return;

    const allowed = ["application/zip","application/x-zip-compressed"];

    if(!allowed.includes(file[0].type)){
      alert("Solo se permiten archivos ZIP");
      return;
    }

    setFiles({
      ...files,
      [name]:file[0]
    });

  };


  // ===============================
  // SUBMIT
  // ===============================

  const handleSubmit = async(e)=>{

    e.preventDefault();

    setError("");
    setSuccess("");

    try{

      const data = new FormData();

      data.append("id_proceso",id);

      Object.keys(formData).forEach(key=>{

        if(key === "department"){

          formData.department.forEach(dep=>{
            data.append("department[]",dep);
          });

        }else{

          data.append(key,formData[key]);

        }

      });

      Object.keys(files).forEach(key=>{

        if(files[key]){
          data.append(key,files[key]);
        }

      });

      const res = await authFetch(
        ENDPOINTS.updateProposal,
        {
          method:"POST",
          body:data
        }
      );

      if(!res.success){
        setError(res.message);
        return;
      }

      setSuccess("Propuesta actualizada correctamente");

      setTimeout(()=>{
        navigate("/session/mod_proyectos/proposal/proposal");
      },1500);

    }catch(err){

      console.error(err);
      setError("Error en el servidor");

    }

  };



  return(

    <div className="p-4">

      <div className="d-flex justify-content-between align-items-center m-3">

        <h3>Editar Propuesta</h3>

        <button
          type="button"
          className="btn btn-outline-pink"
          onClick={()=>navigate("/session/mod_proyectos/proposal/proposal")}
        >
          <i className="bi bi-arrow-left me-1"></i> Volver
        </button>

      </div>

      <form className="card p-4 shadow-sm" onSubmit={handleSubmit}>

        {error && <div className="alert alert-danger">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        {/* FILA 1 */}

        <div className="row">

          <div className="col-md-6 mb-3">

            <label>Entidad *</label>

            <select
              name="id_entidad"
              className="form-select"
              value={formData.id_entidad}
              onChange={handleChange}
            >

              <option value="">Selecciona...</option>

              {entities.map(entity=>(
                <option
                  key={entity.id_entidad}
                  value={entity.id_entidad}
                >
                  {entity.name}
                </option>
              ))}

            </select>

          </div>

          <div className="col-md-6 mb-3">

            <label>Tipo población *</label>

            <select
              name="type_population"
              className="form-select"
              value={formData.type_population}
              onChange={handleChange}
            >

              <option value="">Selecciona...</option>
              <option value="Afrocolombiano">Afrocolombiano</option>
              <option value="Indígena">Indígena</option>
              <option value="Campesino">Campesino</option>
              <option value="Víctimas del conflicto">Víctimas del conflicto</option>
              <option value="Población vulnerable">Población vulnerable</option>
              <option value="Adulto mayor">Adulto mayor</option>
              <option value="Discapacidad">Personas con discapacidad</option>
              <option value="General">Población general</option>

            </select>

          </div>

        </div>


        {/* OBJETO */}

        <div className="mb-3">

          <label>Objeto *</label>

          <textarea
            name="object"
            className="form-control"
            rows="3"
            value={formData.object}
            onChange={handleChange}
          />

        </div>


        {/* DEPARTAMENTOS */}

        <div className="row">

          <div className="col-md-6 mb-3">

            <label>Departamentos *</label>

            <select
              multiple
              className="form-select"
              onChange={handleDepartmentChange}
              value={formData.department}
            >

              {departments.map(dep=>(
                <option
                  key={dep.id_departamento}
                  value={dep.id_departamento}
                >
                  {dep.nombre}
                </option>
              ))}

            </select>

          </div>

          <div className="col-md-6 mb-3">

            <label>Municipios *</label>

            <textarea
              name="municipality"
              className="form-control"
              value={formData.municipality}
              onChange={handleChange}
            />

          </div>

        </div>


        {/* FECHAS */}

        <div className="row">

          <div className="col-md-6 mb-3">

            <label>Fecha inicio *</label>

            <input
              type="date"
              name="start_date"
              className="form-control"
              value={formData.start_date}
              onChange={handleChange}
            />

          </div>

          <div className="col-md-6 mb-3">

            <label>Fecha fin *</label>

            <input
              type="date"
              name="end_date"
              className="form-control"
              value={formData.end_date}
              onChange={handleChange}
            />

          </div>

        </div>


        {/* PRESUPUESTOS */}

        <div className="row">

          <div className="col-md-6 mb-3">

            <label>Presupuesto entidad</label>

            <input
              type="number"
              name="presupuesto_entity"
              className="form-control"
              value={formData.presupuesto_entity}
              onChange={handleChange}
            />

          </div>

          <div className="col-md-6 mb-3">

            <label>Presupuesto presencia</label>

            <input
              type="number"
              name="presupuesto_presencia"
              className="form-control"
              value={formData.presupuesto_presencia}
              onChange={handleChange}
            />

          </div>

        </div>


        {/* DOCUMENTOS */}

        <div className="row">

          <div className="col-md-4 mb-3">

            <label>Documento contratante (ZIP)</label>

            <input
              type="file"
              name="doc_contratante"
              className="form-control"
              accept=".zip"
              onChange={handleFileChange}
            />

          </div>

          <div className="col-md-4 mb-3">

            <label>Propuesta presencia (ZIP)</label>

            <input
              type="file"
              name="doc_propuesta_presencia"
              className="form-control"
              accept=".zip"
              onChange={handleFileChange}
            />

          </div>

          <div className="col-md-4 mb-3">

            <label>Evaluación propuesta (ZIP)</label>

            <input
              type="file"
              name="doc_evaluacion_propuesta"
              className="form-control"
              accept=".zip"
              onChange={handleFileChange}
            />

          </div>

        </div>


        <button type="submit" className="btn btn-outline-pink w-100 mt-4">
          Actualizar propuesta
        </button>

      </form>

    </div>

  );

};

export default UpdateProposal;